import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ExternalProviderSearchState } from 'api';

type ExternalProviderMappingState = {
  searchState: ExternalProviderSearchState;
};

const initialState: ExternalProviderMappingState = {
  searchState: {
    npiSearchValue: 0,
    orgNameSearchValue: '',
    validationErrors: [],
  },
};

export const externalProviderMappingSlice = createSlice({
  name: 'externalProviderMappingSlice',
  initialState,
  reducers: {
    setExternalProviderSearchState: (
      state,
      action: PayloadAction<ExternalProviderSearchState>
    ) => {
      state.searchState.npiSearchValue = action.payload.npiSearchValue;
      state.searchState.orgNameSearchValue = action.payload.orgNameSearchValue;
    },
  },
});

export const { setExternalProviderSearchState } =
  externalProviderMappingSlice.actions;
